// Vue
import Vue from "vue";
import vuetify from "./plugins/vuetify";
// Composition API
import VueCompositionAPI from "@vue/composition-api";
// Pinia
import { createPinia, PiniaVuePlugin } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
// Vue Router
import router from "./router";
import VueRouter from "vue-router";
// i18n
import i18n from "./plugins/i18n";
import { locale, setGlobalLocale } from "./utils/locale";
// Day.js
import { DayJsPlugin } from "@/plugins/dayjs";
// App
import App from "./App.vue";

// Create Pinia instance
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Usings
Vue.use(VueCompositionAPI);
Vue.use(VueRouter);
Vue.use(DayJsPlugin);

Vue.config.productionTip = false;

//Set locale
setGlobalLocale(locale);

new Vue({
  i18n,
  pinia,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
